// find
export const FIND_AMEND_PRINT_REQUEST = "FIND_AMEND_PRINT_REQUEST";
export const FIND_AMEND_PRINT_SUCCESS = "FIND_AMEND_PRINT_SUCCESS";
export const FIND_AMEND_PRINT_FAIL = "FIND_AMEND_PRINT_FAIL";

export const AMEND_PRINT_CLEAR_ERROR = "AMEND_PRINT_CLEAR_ERROR";